(function () {
  "use strict";
  var CONFIG = {
      productUrl: "/products/kiddospace-reusable-water-sponge-balls",
      exitUrl: "/pages/9-reasons-why-water-sponge-balls",
      logoUrl:
        "https://thekiddospacestore.com/cdn/shop/files/New_logo_118x_2x_8455129b-5f9c-4cc5-8d47-906d4b391699_118x.png?v=1746770607",
      topBarText: "Crea il set perfetto per la tua famiglia!",
      trustLine: "3.500+ famiglie felici con garanzia di 90 giorni",
      fixedKit: {
        name: "Il tuo setup estivo è sbloccato",
        tagline:
          "Ideale per giochi d'acqua supervisionati all'aperto su erba o tappetino morbido.",
        price: "\xA329.99",
        comparePrice: "\xA349.99",
        savings: "Risparmi \xA320 oggi",
        variantId: "REPLACE_WITH_VARIANT_ID_1",
        image:
          "https://thekiddospacestore.co.uk/cdn/shop/files/1-Web-Images--Splash-Pad_900x900_4c00c416-6fc4-4c78-830c-d7ef336b8c72_720x720.jpg",
        perks: [
          "Il tuo setup per battaglie d'acqua viene verificato",
          "10 palline spugna extra aggiunte gratuitamente",
          "2 sacchetti a rete aggiunti gratuitamente",
          "Garanzia soddisfatti o rimborsati 90 giorni",
        ],
        reviews: [
          {
            text: "My grandkids absolutely love these! No more balloon mess on the lawn.",
            author: "Sandra M.",
            status: "acquirente verificato \u2714",
          },
          {
            text: "Best purchase this summer. My kids fight over who gets to refill them!",
            author: "Jennifer R.",
            status: "acquirente verificato \u2714",
          },
          {
            text: "Used these at my grandson's birthday, 15 kids going wild for 3 hours. Zero cleanup!",
            author: "Robert K.",
            status: "acquirente verificato \u2714",
          },
        ],
      },
      loadingItems: [
        "Il tuo setup per battaglie d'acqua viene verificato",
        "10 palline spugna extra aggiunte gratuitamente",
        "2 sacchetti a rete aggiunti gratuitamente",
        "Garanzia soddisfatti o rimborsati 90 giorni",
      ],
      steps: [
        {
          id: "who",
          eyebrow: "Domanda 1 di 5",
          question: "Per chi stai acquistando?",
          subtext: "Questo ci aiuta a trovare la soluzione giusta per la tua famiglia.",
          options: [
            {
              value: "My grandkids",
              icon: "\uD83D\uDC75",
              label: "I miei nipoti",
              desc: "I miei nipoti",
            },
            {
              value: "My own kids",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "I miei figli",
              desc: "I miei figli",
            },
            {
              value: "For a party or event",
              icon: "\uD83C\uDF89",
              label: "Per una festa o un evento",
              desc: "Per una festa o un evento",
            },
            {
              value: "It's a gift",
              icon: "\uD83C\uDF81",
              label: "Come regalo",
              desc: "Come regalo",
            },
          ],
        },
        {
          id: "count",
          eyebrow: "Domanda 2 di 5",
          question: "Quanti bambini giocano di solito contemporaneamente?",
          subtext: "Conta tutti quelli che potrebbero partecipare.",
          options: [
            {
              value: "1-2",
              icon: "👦",
              label: "1–2",
            },
            {
              value: "3-4",
              icon: "👧👦",
              label: "3–4",
            },
            {
              value: "5-6",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "5–6",
            },
            {
              value: "7+",
              icon: "\uD83C\uDF8A",
              label: "7+",
            },
          ],
        },
        {
          id: "surface",
          eyebrow: "Domanda 3 di 5",
          question: "Quali fasce d'età parteciperanno principalmente?",
          subtext: "La superficie influisce su quanto rimane stabile.",
          options: [
            {
              value: "1-4",
              icon: "\uD83E\uDDF8",
              label: "1–4",
            },
            {
              value: "5-8",
              icon: "\uD83D\uDCA6",
              label: "5–8",
            },
            {
              value: "9-12",
              icon: "\uD83C\uDFC3",
              label: "9–12",
            },
            {
              value: "Mixed ages",
              icon: "\uD83C\uDF08",
              label: "Età miste",
              desc: "Aiutami a decidere",
            },
          ],
        },
        {
          id: "hose",
          eyebrow: "Domanda 4 di 5",
          question: "Dove le useranno di più?",
          subtext:
            "Lo Splash Pad si collega direttamente a un tubo da giardino standard.",
          options: [
            {
              value: "Garden",
              icon: "\uD83C\uDFE1",
              label: "Giardino",
            },
            {
              value: "Pool",
              icon: "\uD83C\uDFCA",
              label: "Piscina",
            },
            {
              value: "Beach",
              icon: "\uD83C\uDFD6\uFE0F",
              label: "Spiaggia",
            },
            {
              value: "A bit of everything",
              icon: "\uD83C\uDF0D",
              label: "Un po' di tutto",
            },
          ],
        },
        {
          id: "priority",
          eyebrow: "Domanda 5 di 5",
          question: "Cosa è più importante per te?",
          subtext: "Scegli quello che si adatta meglio.",
          options: [
            {
              value: "No balloon waste to clean up",
              icon: "\uD83E\uDDF9",
              label: "Nessun rifiuto da palloncini da raccogliere",
            },
            {
              value: "Refills in seconds",
              icon: "\uD83D\uDCA7",
              label: "Ricarica in pochi secondi",
            },
            {
              value: "Enough for the whole group",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Abbastanza per tutto il gruppo",
            },
            {
              value: "Easy to store",
              icon: "\uD83D\uDC5C",
              label: "Facile da riporre",
            },
            {
              value: "Good value for parties",
              icon: "\uD83C\uDFF7\uFE0F",
              label: "Ottimo rapporto qualità-prezzo per le feste",
            },
          ],
        },
        {
          id: "alternative",
          eyebrow: "Domanda 6 di 6",
          question: "Cosa preferisci:",
          subtext: "Scegli quello che si adatta meglio.",
          options: [
            {
              value: "Just enough",
              icon: "\uD83D\uDC66",
              label: "Appena sufficiente",
              desc: "Appena sufficiente",
            },
            {
              value: "A little extra",
              icon: "\u2795",
              label: "Un po' di più",
              desc: "Un po' di più",
            },
            {
              value: "Cousins and friends",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Abbastanza per cugini e amici",
              desc: "Abbastanza per cugini e amici",
            },
            {
              value: "Party-ready",
              icon: "\uD83C\uDF89",
              label: "Pronto per la festa",
              desc: "Pronto per la festa",
            },
          ],
        },
      ],
    },
    state = { screen: "intro", currentStep: 0, answers: {} };
  function el(id) {
    return document.getElementById(id);
  }
  var stars = "\u2605\u2605\u2605\u2605\u2605";
  function renderIntro() {
    var pBar = el("quiz-progress-wrap");
    pBar && (pBar.style.display = "none");
    var stage = el("quiz-stage");
    stage &&
      ((stage.innerHTML =
        '<div class="quiz-intro"><div class="quiz-intro-badge"><span class="quiz-intro-dot"></span> Richiede solo 1 minuto</div><h1 class="quiz-intro-headline">Trova il set perfetto per le battaglie d\'acqua della tua famiglia!</h1><p class="quiz-intro-sub">Rispondi a 6 brevi domande e ricevi il tuo set personalizzato di palline spugna – <strong>più 10 palline spugna extra in omaggio!</strong></p><div class="quiz-intro-features"><div class="quiz-intro-feature"><span class="quiz-intro-fi">\uD83C\uDF89</span> Niente più pezzi di palloncini da raccogliere</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u26A1</span> Ricarica in 5 secondi da soli</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u2B50</span> Oltre 3.500 recensioni a cinque stelle dalle famiglie</div></div><button class="quiz-btn quiz-intro-btn" id="quiz-start-btn" type="button">Trova il mio set ideale<span class="quiz-btn-arrow">\u2192</span></button><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
      el("quiz-start-btn").addEventListener("click", function () {
        ((state.screen = "quiz"),
          pBar && (pBar.style.display = ""),
          renderStep(0));
      }));
  }
  function renderProgress(idx) {
    var total = CONFIG.steps.length,
      pct = Math.round((idx / total) * 100),
      wrap = el("quiz-progress-wrap");
    wrap &&
      (wrap.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Il tuo set è in preparazione</span><span class="quiz-progress-count">' +
        idx +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:' +
        pct +
        '%"></div></div></div>');
  }
  function optionCard(opt, stepId) {
    var sel = state.answers[stepId] === opt.value;
    return (
      '<button class="quiz-option' +
      (sel ? " selected" : "") +
      '" data-step="' +
      stepId +
      '" data-value="' +
      opt.value +
      '" type="button" aria-pressed="' +
      sel +
      '"><span class="quiz-option-icon">' +
      opt.icon +
      '</span><span class="quiz-option-body"><span class="quiz-option-label">' +
      opt.label +
      '</span><span class="quiz-option-desc">' +
      opt.desc +
      "</span></span></button>"
    );
  }
  function renderStep(idx) {
    var step = CONFIG.steps[idx],
      hasAnswer = !!state.answers[step.id],
      isLast = idx === CONFIG.steps.length - 1,
      stage = el("quiz-stage");
    if (stage) {
      ((stage.innerHTML =
        '<div class="quiz-step"><button class="quiz-back" id="quiz-back-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Indietro</button><p class="quiz-eyebrow">' +
        step.eyebrow +
        '</p><h2 class="quiz-question">' +
        step.question +
        '</h2><p class="quiz-subtext">' +
        step.subtext +
        '</p><div class="quiz-options">' +
        step.options
          .map(function (o) {
            return optionCard(o, step.id);
          })
          .join("") +
        '</div><div class="quiz-btn-wrap"><button class="quiz-btn" id="quiz-next-btn" type="button"' +
        (hasAnswer ? "" : " disabled") +
        ">" +
        (isLast ? "Visualizza il mio consiglio" : "Avanti") +
        ' <span class="quiz-btn-arrow">\u2192</span></button></div><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
        stage.querySelectorAll(".quiz-option").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var stepId = btn.getAttribute("data-step"),
              val = btn.getAttribute("data-value");
            ((state.answers[stepId] = val),
              stage
                .querySelectorAll('.quiz-option[data-step="' + stepId + '"]')
                .forEach(function (b) {
                  var on = b.getAttribute("data-value") === val;
                  (b.classList.toggle("selected", on),
                    b.setAttribute("aria-pressed", on));
                }));
            var nb2 = el("quiz-next-btn");
            nb2 && (nb2.disabled = !1);
          });
        }));
      var nb = el("quiz-next-btn");
      nb && nb.addEventListener("click", advance);
      var bb = el("quiz-back-btn");
      (bb && bb.addEventListener("click", goBack), renderProgress(idx));
    }
  }
  function renderLoading() {
    var pBar = el("quiz-progress-wrap"),
      total = CONFIG.steps.length;
    pBar &&
      (pBar.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Il tuo set consigliato è in preparazione</span><span class="quiz-progress-count">' +
        total +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
    var stage = el("quiz-stage");
    if (stage) {
      var itemsHtml = CONFIG.loadingItems
        .map(function (text, i) {
          return (
            '<div class="loading-item" id="load-item-' +
            i +
            '"><div class="loading-check" id="load-check-' +
            i +
            '"></div><span>' +
            text +
            "</span></div>"
          );
        })
        .join("");
      stage.innerHTML =
        '<div class="quiz-loading" id="quiz-loading-wrap"><div class="loading-spinner" id="loading-spinner"></div><h2 class="loading-title">Visualizza il mio set consigliato \u2026</h2><p class="loading-sub" id="loading-sub">Personalizzazione in base alle tue risposte</p><div class="loading-checklist">' +
        itemsHtml +
        '</div><div id="loading-cta" style="display:none;"><p class="loading-cta-sub">Abbiamo trovato il set perfetto per le battaglie d\'acqua in base alle tue risposte.</p><a class="kit-ready-btn" id="kit-ready-btn" href="#"><span class="kit-ready-btn-badge">40% DI SCONTO</span><span class="kit-ready-btn-text">Visualizza il mio set consigliato \u2192</span></a><div class="quiz-btn-wrap" style="margin-top:14px"><button class="quiz-btn-text" id="kit-retake-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Ripeti il quiz</button></div></div></div>';
      var delays = [0, 1400, 2800, 4200];
      CONFIG.loadingItems.forEach(function (_, i) {
        (setTimeout(function () {
          var item = el("load-item-" + i);
          item && item.classList.add("active");
        }, delays[i]),
          setTimeout(function () {
            var item = el("load-item-" + i),
              check = el("load-check-" + i);
            item &&
              check &&
              (item.classList.remove("active"),
              item.classList.add("done"),
              (check.textContent = "\u2713"));
          }, delays[i] + 1e3));
      });
      var lastDone = delays[delays.length - 1] + 1e3;
      setTimeout(function () {
        var kit = CONFIG.fixedKit,
          url = CONFIG.productUrl;
        kit.variantId &&
          kit.variantId.indexOf("REPLACE_") !== 0 &&
          (url += "?variant=" + kit.variantId);
        var spinner = el("loading-spinner");
        spinner && (spinner.style.display = "none");
        var sub = el("loading-sub");
        sub && (sub.style.display = "none");
        var ctaBtn = el("kit-ready-btn");
        ctaBtn && ctaBtn.setAttribute("href", url);
        var cta = el("loading-cta");
        cta && (cta.style.display = "");
        var rt = el("kit-retake-btn");
        rt &&
          rt.addEventListener("click", function () {
            ((state.screen = "intro"),
              (state.currentStep = 0),
              (state.answers = {}),
              renderIntro());
          });
        var pBar2 = el("quiz-progress-wrap");
        pBar2 &&
          (pBar2.innerHTML =
            '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Il tuo set è pronto!</span><span class="quiz-progress-count">' +
            total +
            " / " +
            total +
            '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
      }, lastDone);
    }
  }
  function advance() {
    var step = CONFIG.steps[state.currentStep];
    state.answers[step.id] &&
      (state.currentStep >= CONFIG.steps.length - 1
        ? renderLoading()
        : (state.currentStep++,
          renderStep(state.currentStep),
          window.scrollTo({ top: 0, behavior: "smooth" })));
  }
  function goBack() {
    if (state.currentStep <= 0) {
      ((state.screen = "intro"), (state.currentStep = 0), renderIntro());
      return;
    }
    (state.currentStep--,
      renderStep(state.currentStep),
      window.scrollTo({ top: 0, behavior: "smooth" }));
  }
  function init() {
    var root = el("quiz-root");
    root &&
      ((root.innerHTML =
        '<div id="quiz-wrapper"><div class="quiz-topbar"><span class="quiz-topbar-time">&lt;1 minuto</span><span class="quiz-topbar-text">' +
        CONFIG.topBarText +
        '</span></div><header class="quiz-header"><img class="quiz-logo" src="' +
        CONFIG.logoUrl +
        '" alt="KiddoSpace"></header><div id="quiz-progress-wrap" style="display:none"></div><main id="quiz-stage" class="quiz-stage" aria-live="polite"></main></div>'),
      renderIntro());
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
//# sourceMappingURL=/s/files/1/0760/0662/1462/files/Splash_Pad_Quiz.js.map?v=1780486916